import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const indicatorFields: FieldInterface[] = [
  {
    key: 'available',
    originKey: 'available',
    type: FIELD_TYPES.boolean,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'issues',
    originKey: 'issues',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
    isMultiple: true,
  },
  {
    key: 'name',
    originKey: 'name',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'result',
    originKey: 'result',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'configuration',
    originKey: 'configuration',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'skippable',
    originKey: 'skippable',
    type: FIELD_TYPES.boolean,
    rule: FIELD_RULES.isReadOnly,
  },
]

const indicatorRelations: RelationInterface[] = [
  {
    key: '_wealthRecommendationProducts',
    originKey: 'wealth_recommendation_products',
    objectType: OBJECT_TYPES.products,
    isMultiple: true,
  },
]

export { indicatorFields, indicatorRelations }
